import { useRef, useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import api from "services/api";

import getQueryParams from "common/get-query-params";
import encodeQueryParams from "common/encode-query-params";
import serveRequestErrors from "common/serve-request-errors";
import serveRequestSuccess from "common/serve-request-success";

import CONSTANTS from "constants/constant";

import ActionEnum from "enum/action";

import ErrorResponseDto from "dto/services/error-response-dto";
import PageEnquiryDto, { PageEnquiryTableQueryParamsDto, PageEnquiryTableUpdatePayloadDto } from "dto/pages/enquiry/page-enquiry-dto";

import AppHeading from "components/app-heading";
import EnquiryTable from "components/pages/page-enquiry/app-enquiry-table";

const PageEnquiry = () => {
	const [enquiryData, setEnquiryData] = useState<PageEnquiryDto>();
	const [searchParams, setSearchParams] = useSearchParams();
	const memoSetSearchParams = useRef(setSearchParams);
	const [isFetching, setIsFetching] = useState(false);
	const queryParams = useRef(getQueryParams<PageEnquiryTableQueryParamsDto>(searchParams, { page: 0 }));

	const onHandleGetEnquiry = useCallback(async () => {
		setIsFetching(true);

		try {
			const { page } = queryParams.current;
			const payload = { size: 10, page };
			const response = await api.get.enquiry.enquiries(payload);

			setEnquiryData(response.data.data.list);
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);
		} finally {
			setIsFetching(false);
		}
	}, []);

	//prettier-ignore
	const onUpdateEnquiry = useCallback(async (payload: PageEnquiryTableUpdatePayloadDto) => {
		let response = null;

		try {
			response = await api.put.enquiry.update({ id: payload.id }, payload);
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);
		}

		if (response) {
			serveRequestSuccess(CONSTANTS.MESSAGES.UPDATED, ActionEnum.Update);

			onHandleGetEnquiry();
		}
	}, [onHandleGetEnquiry]);

	const onHandlePageChange = (page: number) => {
		queryParams.current.page = page;
		memoSetSearchParams.current(encodeQueryParams(queryParams.current));

		onHandleGetEnquiry();
	};

	useEffect(() => {
		onHandleGetEnquiry();
	}, [onHandleGetEnquiry]);

	return (
		<div className="page-enquiry">
			<div className="enquiry">
				<AppHeading title="Enquiry">
					<AppHeading.Divider />
				</AppHeading>

				{/* prettier-ignore */}
				<EnquiryTable enquiries={enquiryData?.content || []} onUpdateStatus={onUpdateEnquiry} onHandlePageChange={onHandlePageChange} fetching={isFetching} paginationTable={{currentPage: enquiryData?.number || 0, totalPages: enquiryData?.totalPages || 0, numberOfElements: enquiryData?.numberOfElements || 0, tableSize: enquiryData?.size || 10 }} />
			</div>
		</div>
	);
};

export default PageEnquiry;
